import { render, staticRenderFns } from "./CartTakeOutUser.vue?vue&type=template&id=67cb87d5&scoped=true&"
import script from "./CartTakeOutUser.vue?vue&type=script&lang=js&"
export * from "./CartTakeOutUser.vue?vue&type=script&lang=js&"
import style0 from "./CartTakeOutUser.vue?vue&type=style&index=0&id=67cb87d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb87d5",
  null
  
)

export default component.exports